import { serverErrors } from "@shared/constants/app";

export interface Slide {
  imgForPhone: string;
  imgForTablet: string;
  img?: string;
  title?: {
    id: string;
  };
  content?: {
    id: string;
  };
  button?: {
    id: string;
  };
  video: {
    sources: Array<Video>;
  };
  className: string;
}

export interface Brand {
  id: number;
  name: string;
  string_id: string;
}

export interface Video {
  src: string;
  type: string;
}
export const enum RunType {
  game_list = "game_list", // основной список в лобби
  favourites = "favourites",
  recommendation = "recommendation",
  banner = "banner",
}

export interface SerializedGame {
  close_button?: boolean;
  default_config_id?: number;
  delete_time?: Date;
  description: string;
  enabled: boolean;
  external_jackpot: boolean;
  game_provider_id: number;
  game_section_id: number;
  id: number;
  internal_jackpot: boolean;
  is_favorite: boolean;
  jackpot_slots_count: number;
  lowerCaseName: string;
  name: string;
  pic: string;
  popularity: number;
  string_id: string;
  tags: Array<Tag>;
}

export interface Tag {
  id: number;
  name: string;
  priority: number;
}

export type TServerRegistrationErrors = keyof typeof serverErrors;
